<template>
	<div class="addons">
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Opcje dodatkowe</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small><br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div class="addons__main">
			<div class="addons__container">
				<div class="addons__colors">
					<h4 class="addons__header">Wybierz kolor dodatkowy</h4>
					<small class="addons_hint">Wybierz jedną opcję</small>
					<Radio
						v-for="(option, index) in extraColorOptions"
						:key="`extra-color-option__${index}`"
						class="addons__radio"
						name="extra-color-option"
						:value="option.name"
						:checked="option.name === selectedExtraColorOption"
						@change="handleExtraColorOptionChange"
					>
						<span class="addons__radio-label">
							{{ option.fullName }}
						</span>
						<span class="addons__radio-cost" slot="right-addon">
							{{ formatPrice(option.cost) }}
						</span>
					</Radio>
				</div>
				<div class="addons__options">
					<h4 class="addons__header">Opcje dodatkowe</h4>
					<Radio
						v-for="(addon, index) in addons"
						:key="`addon__${index}`"
						class="addons__radio"
						name="addon"
						:value="addon.name"
						:checked="selectedAddons.includes(addon.name)"
						@change="handleAddonChange"
						multiple
						:checkbox="true"
						:emitValueOnUncheck="true"
					>
						<span class="addons__radio-label">
							{{ addon.fullName }}
						</span>
						<span class="addons__radio-cost" slot="right-addon">
							{{ formatPrice(addon.cost) }}
						</span>
					</Radio>
				</div>
			</div>
			<div class="addons__preview">
				<img class="addons__unit-preview" :src="require('@/assets/pictures/' + unit.image)" />
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import Radio from '@/components/Radio';

export default {
	name: 'Addons',
	mixins: [AppDataMixin],
	components: {Radio},
	data() {
		return {
			extraColorOptions: [],
			addons: [],
		};
	},
	computed: {
		selectedExtraColorOption() {
			return this.$store.state.unitConfiguration.extraColorOption || '';
		},
		selectedAddons() {
			return this.$store.state.unitConfiguration.addons;
		},
	},
	mounted() {
		this.extraColorOptions = this.getAppData('extraColorOptionsList');
		this.addons = this.getAppData('addonsList');
	},
	methods: {
		handleExtraColorOptionChange(colorOption) {
			this.$store.commit('unitConfiguration/setExtraColorOption', colorOption);
		},

		handleAddonChange(addon) {
			this.$store.commit('unitConfiguration/setAddons', addon);
		},
	},
};
</script>
